const json = {
  '2020-01': require('./json/days/2020-01.json'),
  '2020-02': require('./json/days/2020-02.json'),
  '2020-03': require('./json/days/2020-03.json'),
  '2020-04': require('./json/days/2020-04.json'),
  '2020-05': require('./json/days/2020-05.json'),
  '2020-06': require('./json/days/2020-06.json'),
  '2020-07': require('./json/days/2020-07.json'),
  '2020-08': require('./json/days/2020-08.json'),
  '2020-09': require('./json/days/2020-09.json'),
  '2020-10': require('./json/days/2020-10.json'),
  '2020-11': require('./json/days/2020-11.json'),
  '2020-12': require('./json/days/2020-12.json'),
  '2021-01': require('./json/days/2021-01.json'),
  '2021-02': require('./json/days/2021-02.json'),
  '2021-03': require('./json/days/2021-03.json'),
  '2021-04': require('./json/days/2021-04.json'),
  '2021-05': require('./json/days/2021-05.json'),
  '2021-06': require('./json/days/2021-06.json'),
  '2021-07': require('./json/days/2021-07.json'),
  '2021-08': require('./json/days/2021-08.json'),
  '2021-09': require('./json/days/2021-09.json'),
  '2021-10': require('./json/days/2021-10.json'),
  '2021-11': require('./json/days/2021-11.json'),
  '2021-12': require('./json/days/2021-12.json'),
  '2022-01': require('./json/days/2022-01.json'),
  '2022-02': require('./json/days/2022-02.json'),
  '2022-03': require('./json/days/2022-03.json'),
  '2022-04': require('./json/days/2022-04.json'),
  '2022-05': require('./json/days/2022-05.json'),
  '2022-06': require('./json/days/2022-06.json'),
  '2022-07': require('./json/days/2022-07.json'),
  '2022-08': require('./json/days/2022-08.json'),
  '2022-09': require('./json/days/2022-09.json'),
  '2022-10': require('./json/days/2022-10.json'),
  '2022-11': require('./json/days/2022-11.json'),
  '2022-12': require('./json/days/2022-12.json'),
  '2023-01': require('./json/days/2023-01.json'),
  '2023-02': require('./json/days/2023-02.json'),
  '2023-03': require('./json/days/2023-03.json'),
  '2023-04': require('./json/days/2023-04.json'),
  '2023-05': require('./json/days/2023-05.json'),
  '2023-06': require('./json/days/2023-06.json'),
  '2023-07': require('./json/days/2023-07.json'),
  '2023-08': require('./json/days/2023-08.json'),
  '2023-09': require('./json/days/2023-09.json'),
  '2023-10': require('./json/days/2023-10.json'),
  '2023-11': require('./json/days/2023-11.json'),
  '2023-12': require('./json/days/2023-12.json'),
  '2024-01': require('./json/days/2024-01.json'),
  '2024-02': require('./json/days/2024-02.json'),
  '2024-03': require('./json/days/2024-03.json'),
  '2024-04': require('./json/days/2024-04.json'),
  '2024-05': require('./json/days/2024-05.json'),
  '2024-06': require('./json/days/2024-06.json'),
  '2024-07': require('./json/days/2024-07.json'),
  '2024-08': require('./json/days/2024-08.json'),
  '2024-09': require('./json/days/2024-09.json'),
  '2024-10': require('./json/days/2024-10.json'),
  '2024-11': require('./json/days/2024-11.json'),
  '2024-12': require('./json/days/2024-12.json'),
  '2025-01': require('./json/days/2025-01.json'),
  '2025-02': require('./json/days/2025-02.json'),
  '2025-03': require('./json/days/2025-03.json'),
  '2025-04': require('./json/days/2025-04.json'),
  '2025-05': require('./json/days/2025-05.json'),
  '2025-06': require('./json/days/2025-06.json'),
  '2025-07': require('./json/days/2025-07.json'),
  '2025-08': require('./json/days/2025-08.json'),
  '2025-09': require('./json/days/2025-09.json'),
  '2025-10': require('./json/days/2025-10.json'),
  '2025-11': require('./json/days/2025-11.json')
 
};

export default json;
